module.exports = __webpack_public_path__ + "static/img/son3_active.53ff5a5a.png";